import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const OutstandingPage = lazy(() => import("@/pages/reports.outstanding.page"));

export const Route = createFileRoute("/reports/outstanding")({
  component: OutstandingPage,
});
